module.exports = __webpack_public_path__ + "static/media/helpinghands.3e1c5407.svg";